import { render, staticRenderFns } from "./PendingOrganizationDetails.vue?vue&type=template&id=9933eaf6&scoped=true&"
import script from "./PendingOrganizationDetails.vue?vue&type=script&lang=js&"
export * from "./PendingOrganizationDetails.vue?vue&type=script&lang=js&"
import style0 from "./PendingOrganizationDetails.vue?vue&type=style&index=0&id=9933eaf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9933eaf6",
  null
  
)

export default component.exports